<template>
	<div>
		<el-dialog
			:title="titleDialog"
			:visible="showDialog"
			@close="close"
			@open="create"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			width="45%"
		>
			<form autocomplete="off" @submit.prevent="submit">
				<v-row>
					<v-col cols="12" xl="12">
						<div class="form-group" :class="{ 'error--text': errors.salon_id }">
							<label>Piso</label>
							<el-select v-model="form.salon_id" dusk="salon_id">
								<el-option
									v-for="option in salons"
									:key="option.id"
									:value="option.id"
									:label="option.name"
								></el-option>
							</el-select>
							<small
								class="error--text"
								v-if="errors.salon_id"
								v-text="errors.salon_id[0]"
							></small>
						</div>
					</v-col>
					<v-col cols="12" xl="12">
						<div class="form-group" :class="{ 'error--text': errors.room_type_id }">
							<label>Tipo de habitación</label>
							<el-select v-model="form.room_type_id" dusk="room_type_id">
								<el-option
									v-for="option in room_types"
									:key="option.id"
									:value="option.id"
									:label="option.name"
								></el-option>
							</el-select>
							<small
								class="error--text"
								v-if="errors.room_type_id"
								v-text="errors.room_type_id[0]"
							></small>
						</div>
					</v-col>
					<v-col cols="12" xl="12">
						<div class="form-group" :class="{ 'error--text': errors.name }">
							<label>Nombre</label>
							<el-input v-model="form.name"></el-input>
							<small
								class="error--text"
								v-if="errors.name"
								v-text="errors.name[0]"
							></small>
						</div>
					</v-col>
					<v-col cols="12" xl="12">
						<div class="form-group" :class="{ 'error--text': errors.description }">
							<label>Descripción</label>
							<el-input v-model="form.description"></el-input>
							<small
								class="error--text"
								v-if="errors.description"
								v-text="errors.description[0]"
							></small>
						</div>
					</v-col>
					<v-col cols="12" xl="12">
						<div class="form-group" :class="{ 'error--text': errors.number_of_beds }">
							<label>N° de camas</label>
							<el-input-number
								v-model="form.number_of_beds"
								:min="1"
								:max="5"
								controls-position="right"
							></el-input-number>
							<small
								class="error--text"
								v-if="errors.number_of_beds"
								v-text="errors.number_of_beds[0]"
							></small>
						</div>
					</v-col>
					<v-col cols="12">
						<el-checkbox v-model="form.in_maintenance">En mantenimiento</el-checkbox>
					</v-col>
				</v-row>
				<div class="form-actions text-right mt-3 mb-3">
					<el-button type="danger" @click.prevent="close()">Cancelar</el-button>
					<el-button type="primary" native-type="submit" :loading="loading">
						<template v-if="loading">
							Guardando...
						</template>
						<template v-else>
							Guardar
						</template>
					</el-button>
				</div>
			</form>
		</el-dialog>
	</div>
</template>

<script>
export default {
	props: ['showDialog', 'recordId'],
	data() {
		return {
			loading: false,
			titleDialog: null,
			resource: 'rooms',
			valid: false,
			room_types: [],
			salons: [],
			errors: {},
			form: {},
		};
	},
	created() {},
	methods: {
		initForm() {
			this.errors = {};
			this.form = {
				id: null,
				salon_id: null,
				room_type_id: null,
				room_state_id: '01',
				name: null,
				description: null,
				number_of_beds: 1,
				in_maintenance: false,
			};
		},
		changeScene() {
			console.log(this.form.room_type_id);
		},
		async create() {
			this.titleDialog = this.recordId ? 'Editar habitación' : 'Nueva habitación';
			await this.initForm();
			await this.getTables();

			if (this.recordId) {
				this.$http.get(`/${this.resource}/record/${this.recordId}`).then((response) => {
					this.form = response.data.data;

					console.log(this.form.in_maintenance);
				});
			}
		},
		getTables() {
			this.$http.get(`/${this.resource}/tables`).then((response) => {
				this.room_types = response.data.room_types;
				this.salons = response.data.salons;

				this.form.room_type_id = this.room_types.length > 0 ? this.room_types[0].id : null;
				this.form.salon_id = this.salons.length > 0 ? this.salons[0].id : null;
			});
		},
		submit() {
			this.loading = true;
			this.$http
				.post(`/${this.resource}`, this.form)
				.then((response) => {
					if (response.data.success) {
						this.$message.success(response.data.message);
						this.$eventHub.$emit('reloadData', this.resource);
						if (this.form.id) {
							this.close();
						}
						this.initForm();
					} else {
						this.$message.error(response.data.message);
					}
				})
				.catch((error) => {
					if (error.response.status === 422) {
						this.errors = error.response.data.errors;
					} else {
						this.$message.error(error.response.data.message);
					}
				})
				.then(() => {
					this.loading = false;
				});
		},
		close() {
			this.$emit('update:showDialog', false);
			this.initForm();
		},
	},
};
</script>
